import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'mon-global-toast-container',
    standalone: true,
    imports: [ToastModule],
    template: `
        <p-toast position="bottom-right" [baseZIndex]="9100" />
    `,
})
export class GlobalToastContainerComponent {}
